/* LAFUHQE Accessibility Kit — widget behaviour + preference persistence */
(function () {
  'use strict';

  var STORAGE_KEY = 'lafuhqe-a11y';
  var OPTION_CLASSES = {
    readableFont: 'a11y-font',
    highContrast: 'a11y-contrast',
    underlineLinks: 'a11y-links',
    stopAnimations: 'a11y-motion',
    bigCursor: 'a11y-cursor'
  };
  var OPTION_LABELS = {
    readableFont: 'Easy-read font',
    highContrast: 'High contrast',
    underlineLinks: 'Underline links',
    stopAnimations: 'Stop animations',
    bigCursor: 'Large cursor'
  };

  var root = document.documentElement;
  var kit = document.querySelector('[data-a11y-kit]');
  if (!kit) return;

  var toggle = kit.querySelector('[data-a11y-toggle]');
  var panel = kit.querySelector('#A11yPanel');
  var closeBtn = kit.querySelector('[data-a11y-close]');
  var status = kit.querySelector('[data-a11y-status]');

  function loadSettings() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function saveSettings(settings) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (e) {
      /* private browsing — settings just won't persist */
    }
  }

  function announce(message) {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 50);
  }

  function applySettings(settings) {
    root.classList.toggle('a11y-text-1', settings.textSize === 1);
    root.classList.toggle('a11y-text-2', settings.textSize === 2);
    Object.keys(OPTION_CLASSES).forEach(function (key) {
      root.classList.toggle(OPTION_CLASSES[key], Boolean(settings[key]));
    });
    syncControls(settings);
  }

  function syncControls(settings) {
    kit.querySelectorAll('[data-a11y-size]').forEach(function (btn) {
      var size = Number(btn.getAttribute('data-a11y-size'));
      btn.setAttribute('aria-checked', String(size === (settings.textSize || 0)));
    });
    kit.querySelectorAll('[data-a11y-option]').forEach(function (btn) {
      var key = btn.getAttribute('data-a11y-option');
      btn.setAttribute('aria-checked', String(Boolean(settings[key])));
    });
  }

  var settings = loadSettings();
  applySettings(settings);

  /* --- Panel open/close --- */

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button, a');
    if (first) first.focus();
  }

  function closePanel(refocus) {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (refocus) toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) {
      openPanel();
    } else {
      closePanel(true);
    }
  });

  closeBtn.addEventListener('click', function () {
    closePanel(true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) {
      closePanel(true);
    }
  });

  document.addEventListener('click', function (event) {
    if (!panel.hidden && !kit.contains(event.target)) {
      closePanel(false);
    }
  });

  /* --- Controls --- */

  kit.querySelectorAll('[data-a11y-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      settings.textSize = Number(btn.getAttribute('data-a11y-size'));
      saveSettings(settings);
      applySettings(settings);
      announce(
        settings.textSize === 0 ? 'Default text size' : settings.textSize === 1 ? 'Larger text on' : 'Largest text on'
      );
    });
  });

  kit.querySelectorAll('[data-a11y-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-a11y-option');
      settings[key] = !settings[key];
      saveSettings(settings);
      applySettings(settings);
      announce(OPTION_LABELS[key] + (settings[key] ? ' on' : ' off'));
    });
  });

  kit.querySelector('[data-a11y-reset]').addEventListener('click', function () {
    settings = {};
    saveSettings(settings);
    applySettings(settings);
    announce('Accessibility settings reset');
  });
})();
